<script setup>
    import { defineProps, ref } from "vue";

    const props = defineProps({
        url: {
            type: String,
            default: "",
        },
        metaDescription: {
            type: String,
            default: "",
        },
    });

    const socialData = [
        { network: "LinkedIn" },
        { network: "Facebook" },
        { network: "Twitter" },
        { network: "Whatsapp" },
        { network: "Email" },
    ];

    const isModalOpen = ref(false);

    const openModal = () => {
        isModalOpen.value = true;
    }

    const onClickOutside = () => {
        isModalOpen.value = false;
    }
</script>

<template>
    <button class="share-button" @click="openModal">
        <i>
            <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1" width="13px" height="15px">
                <g transform="matrix(1 0 0 1 -943 -762 )">
                    <path d="M 12.93861111111111 12.804878048780491  C 12.93861111111111 11.626829268292687  11.99611111111111 10.671951219512199  10.833333333333334 10.671951219512197  C 10.284444444444443 10.671951219512197  9.789722222222222 10.887804878048781  9.414166666666667 11.235365853658536  L 4.2683333333333335 8.19512195121951  C 4.308055555555557 8.03048780487805  4.333333333333334 7.858536585365853  4.333333333333334 7.682926829268293  C 4.333333333333334 7.507317073170733  4.308055555555557 7.335365853658536  4.2683333333333335 7.170731707317073  L 9.360000000000001 4.159756097560976  C 9.74638888888889 4.525609756097562  10.262777777777778 4.752439024390245  10.833333333333334 4.752439024390245  C 12.028611111111113 4.752439024390245  13 3.76829268292683  13 2.5573170731707324  C 13 1.3463414634146347  12.028611111111113 0.3621951219512203  10.833333333333334 0.3621951219512203  C 9.638055555555555 0.3621951219512203  8.666666666666666 1.3463414634146347  8.666666666666666 2.5573170731707324  C 8.666666666666666 2.7329268292682936  8.691944444444445 2.904878048780488  8.731666666666666 3.0695121951219524  L 3.6400000000000006 6.080487804878051  C 3.253611111111111 5.714634146341465  2.737222222222222 5.487804878048782  2.1666666666666665 5.487804878048782  C 0.9713888888888886 5.487804878048782  0 6.471951219512197  0 7.682926829268294  C 0 8.89390243902439  0.9713888888888886 9.878048780487807  2.1666666666666665 9.878048780487807  C 2.737222222222222 9.878048780487807  3.253611111111111 9.651219512195123  3.6400000000000006 9.285365853658538  L 8.785833333333333 12.325609756097561  C 8.749722222222221 12.47926829268293  8.728055555555557 12.640243902439025  8.728055555555557 12.804878048780491  C 8.728055555555557 13.982926829268296  9.670555555555556 14.937804878048782  10.833333333333334 14.937804878048782  C 11.99611111111111 14.937804878048782  12.93861111111111 13.982926829268296  12.93861111111111 12.804878048780491  Z " fill-rule="nonzero" fill="#a3277b" stroke="none" transform="matrix(1 0 0 1 943 762 )"/>
                </g>
            </svg>
        </i>
        <span>Share</span>
    </button>
        <div class="share-modal__bg" v-if="isModalOpen">
            <div class="share-modal__content" v-click-outside="onClickOutside">
                <i 
                    @click="onClickOutside"
                    class="share-modal__close"
                >
                    <svg
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        width="9px"
                        height="9px"
                    >
                        <g transform="matrix(1 0 0 1 -477 -405 )">
                        <path
                            d="M 5.409642857142856 4.5  L 9 0.9096428571428572  L 8.090357142857144 0  L 4.5 3.590357142857143  L 0.9096428571428572 0  L 0 0.9096428571428572  L 3.590357142857143 4.5  L 0 8.090357142857144  L 0.9096428571428572 9  L 4.5 5.409642857142856  L 8.090357142857144 9  L 9 8.090357142857144  L 5.409642857142856 4.5  Z "
                            fill-rule="nonzero"
                            fill="#a3277b"
                            stroke="none"
                            transform="matrix(1 0 0 1 477 405 )"
                        />
                        </g>
                    </svg>
                </i>
                <h3>Share this link via</h3>
                <div class="share-modal__links">
                    <div class="share-links">
                        <ShareNetwork
                            v-for="data in socialData"
                            :key="data.network"
                            :network="data.network"
                            :url="props.url"
                            :description="props.metaDescription"
                            title="SERGS"
                            quote="SERGS"
                            hashtags="sergs"
                        >
                        </ShareNetwork>
                    </div>
                </div>
            </div>
        </div>
</template>

<style lang="scss">
    .share-modal {
        &__bg {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 999;
        }

        &__content {
            width: 375px;
            height: auto;
            background-color: white;
            border-radius: 12px;
            padding: 32px 24px;
            position: relative;

            h3 {
                margin: 0 0 24px 0;
            }
        }

        &__links {
            .share-links {
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                align-items: center;
                gap: 44px;
            }
        }

        &__close {
            width: 20px;
            height: 20px;
            display: grid;
            place-items: center;
            position: absolute;
            top: 24px;
            right: 24px;
        }
    }

    .share-network {
        &-linkedin {
            &::before {
                content: "";
                background: url("/dist/img/ico_linkedin.svg") center center / cover no-repeat;
                width: 24px;
                height: 24px;
                display: inline-block;
            }
        }

        &-facebook {
            &::before {
                content: "";
                background: url("/dist/img/ico_facebook.svg") center center / cover no-repeat;
                width: 13px;
                height: 22px;
                display: inline-block;
            }
        }

        &-twitter {
            &::before {
                content: "";
                background: url("/dist/img/ico_twitter.svg") center center / cover no-repeat;
                width: 25px;
                height: 20px;
                display: inline-block;
            }
        }

        &-whatsapp {
            &::before {
                content: "";
                background: url("/dist/img/ico_whatsapp.svg") center center / cover no-repeat;
                width: 25px;
                height: 24px;
                display: inline-block;
            }
        }

        &-email {
            &::before {
                content: "";
                background: url("/dist/img/ico_email.svg") center center / cover no-repeat;
                width: 25px;
                height: 24px;
                display: inline-block;
            }
        }
    }
</style>